import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import { createContext, useContext, useMemo, useState } from "react";
export const AssetModalThemeContext = /*#__PURE__*/ createContext(undefined);
export const useAssetModalTheme = ()=>{
    const ctx = useContext(AssetModalThemeContext);
    if (!ctx) {
        const error = new Error("useAssetModalTheme must be used within AssetModalThemeContext.Provider");
        reportErrorToBugsnag({
            error,
            context: "Asset Modal theme context not found"
        });
        throw error;
    }
    return ctx;
};
export const AssetModalThemeContextProvider = (param)=>{
    let { children } = param;
    const [theme, setTheme] = useState("dark");
    const contextValue = useMemo(()=>({
            theme,
            setTheme
        }), [
        theme
    ]);
    return /*#__PURE__*/ _jsx(AssetModalThemeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ _jsx("div", {
            "data-theme": theme,
            children: children
        })
    });
};
